import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import {
  AnalyticsDataPopulateService,
  AnalyticsService,
  FilterData,
  PopulateAnalytics
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { RecentListItem } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  PredictiveSearch,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '../../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import { BookWidgetFilterDataService } from '../../../../services/book-widget-filter-data.service';

@Component({
  standalone: true,
  template: ''
})
export class HomeBookWidgetBaseComponent {
  @Output() analyticsEvent = new EventEmitter<PopulateAnalytics>();
  @Input() bookWidgetAem!: BookWidgetAem;
  @Input() bookWidgetFields!: BookWidgetFields;
  @Input() isAdvancedSearchExpanded = false;
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() isFullscreen!: boolean;
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;
  //mobile
  @Input() viewSearchOptionExpanded = false;

  @Output() infoIconClick: EventEmitter<BookWidgetFieldInfoTypes> =
    new EventEmitter<BookWidgetFieldInfoTypes>();

  @Output() bookWidgetFieldChange =
    new EventEmitter<BookWidgetFieldUpdateEvent>();

  @Output() swapClicked = new EventEmitter<number>();
  @Output() findFlight = new EventEmitter();
  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();
  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() addFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewSearchOptionEvent = new EventEmitter();
  @Output() toggleAdvSearchExpandedEvent = new EventEmitter();

  filterDataService = inject(BookWidgetFilterDataService);
  protected analyticsDataPopulateService = inject(AnalyticsDataPopulateService);
  protected analyticsService = inject(AnalyticsService);

  protected mcRowsTrackByFn = (index: number) => index;
  protected get tripTypeOptions() {
    return TripTypeOptions;
  }

  protected get bookWidgetFieldInfoTypes() {
    return BookWidgetFieldInfoTypes;
  }

  protected get bookWidgetFieldUpdateTypes() {
    return BookWidgetFieldUpdateTypes;
  }

  protected onAddFlight() {
    this.addFlight.emit();
  }

  protected onRemoveFlight() {
    this.removeFlight.emit();
  }

  protected collectFilterData(): FilterData[] {
    return this.filterDataService.collectFilterData(
      this.bookWidgetFields,
      this.bookWidgetAem
    );
  }

  protected handleTooltipAnalytics(
    sourceIcon: BookWidgetFieldInfoTypes,
    event: Event
  ) {
    if (sourceIcon === BookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY) {
      const target = event.target as HTMLElement;
      const action = target.getAttribute('data-acdl-action') || '';
      const pageSection = target.getAttribute('data-acdl-page-section') || '';

      const analytics = this.analyticsDataPopulateService.createBaseAnalytics(
        'click',
        action,
        true
      );

      const clickAnalytics = {
        ...analytics,
        click: {
          name: 'refundable fares only tooltip',
          type: 'icon',
          page_section: pageSection,
          action: action
        }
      };

      this.analyticsService.setAnalytics(clickAnalytics);
    }
  }

  onFindFlightClick(elementRef: HTMLElement) {
    this.findFlight.emit();
    const filters = this.collectFilterData();
    this.analyticsEvent.emit({
      el: elementRef,
      event: undefined,
      search: undefined,
      useAttrs: undefined,
      filters
    });
  }
}
